import { render, staticRenderFns } from "./CompetitorInfo.vue?vue&type=template&id=158dbd40&scoped=true"
import script from "./CompetitorInfo.vue?vue&type=script&lang=js"
export * from "./CompetitorInfo.vue?vue&type=script&lang=js"
import style0 from "./CompetitorInfo.vue?vue&type=style&index=0&id=158dbd40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158dbd40",
  null
  
)

export default component.exports